var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.308,
    height: 45.308,
    viewBox: "0 0 45.308 45.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5857",
    "data-name": "Group 5857",
    transform: "translate(-432.846 -5707.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5856",
    "data-name": "Group 5856",
    transform: "translate(432.846 5707.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M0,0V45.308H45.308V23.019H34.266v11.04H11.249V11.042h11.04V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M18.761,0,36.22,17.459V0Z",
    transform: "translate(8.535 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainWhite);
export default __webpack_public_path__ + "static/media/main-white.67759124f41d5064882b49fe9e53045d.svg";
export { ForwardRef as ReactComponent };